module.exports = __webpack_public_path__ + "static/media/logo_reviewer_2.9ceaae5a.svg";